import { natureService } from '../services'

const state = {
  natures: [],
  actionNatures: [],
  nature: null,
  informationNatures: [],
  files: [],
  file: null
}

const getters = {
  findAll (state) {
    return state.natures
  },
  findActionNatures (state) {
    return state.actionNatures
  },
  getAllInformationNatures (state) {
    return state.informationNatures
  },
  find (state) {
    return id => state.natures.find(nature => nature.id === id)
  },
  currentNature (state) {
    return state.nature
  }
}

const mutations = {
  createInformationNature (state, item) {
    const foundAt = state.informationNatures.findIndex(informationNature => informationNature.id === item.id)
    if (foundAt === -1) {
      state.informationNatures.push(item)
    }
  },
  updateInformationNature (state, { id, item }) {
    const foundAt = state.informationNatures.findIndex(informationNature => informationNature.id === id)
    if (foundAt > -1) {
      state.informationNatures.splice(foundAt, 1, item)
    }
  },
  deleteInformationNature (state, id) {
    const foundAt = state.informationNatures.findIndex(nature => nature.id === id)
    if (foundAt > -1) {
      state.informationNatures.splice(foundAt, 1)
    }
  },
  createActionNature (state, item) {
    const foundAt = state.actionNatures.findIndex(actionNature => actionNature.id === item.id)
    if (foundAt === -1) {
      state.actionNatures.push(item)
    }
  },
  updateActionNature (state, { id, item }) {
    const foundAt = state.actionNatures.findIndex(actionNature => actionNature.id === id)
    if (foundAt > -1) {
      state.actionNatures.splice(foundAt, 1, item)
    }
  },
  deleteActionNature (state, id) {
    const foundAt = state.actionNatures.findIndex(nature => nature.id === id)

    if (foundAt > -1) {
      state.actionNatures.splice(foundAt, 1)
    }
  },
  createEventNature (state, item) {
    const foundAt = state.natures.findIndex(nature => nature.id === item.id)
    if (foundAt === -1) {
      state.natures.push(item)
    }
  },
  updateEventNature (state, { id, item }) {
    const foundAt = state.natures.findIndex(nature => nature.id === id)
    if (foundAt > -1) {
      state.natures.splice(foundAt, 1, item)
    }
  },
  deleteEventNature (state, id) {
    const foundAt = state.natures.findIndex(nature => nature.id === id)

    if (foundAt > -1) {
      state.natures.splice(foundAt, 1)
    }
  },
  getAll (state, natures) {
    state.natures = natures
  },
  getAllInformationNatures (state, informationNatures) {
    state.informationNatures = informationNatures
  },
  find (state, nature) {
    state.nature = nature
  },
  findActionNatures (state, natures) {
    state.actionNatures = natures
  }
}

const actions = {
  findAll (context) {
    return natureService.findAll()
      .then(response => {
        context.commit('getAll', response.data)
      })
  },
  findActionNatures (context) {
    return natureService.findActionNatures()
      .then(response => {
        context.commit('findActionNatures', response.data)
      })
  },
  findAllInformationNatures (context) {
    return natureService.findAllInformationNatures()
      .then(response => {
        context.commit('getAllInformationNatures', response.data)
      })
  },
  createInformationNature (context, nature) {
    context.dispatch('loader/startLoading', 'nature/createInformationNature', { root: true })
    return natureService.createInformationNature(nature)
      .then(response => {
        context.dispatch('alert/success', `Création réussie de la nature (information) ${response.data.label}.`, { root: true })
        context.commit('createInformationNature', response.data)
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la création de la nature (information) ${nature.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'nature/createInformationNature', { root: true })
      })
  },
  updateInformationNature (context, { id, nature }) {
    context.dispatch('loader/startLoading', 'nature/updateInformationNature', { root: true })
    return natureService.updateInformationNature(id, nature)
      .then(response => {
        context.dispatch('alert/success', `Mise à jour réussie de la nature (information) ${response.data.label}.`, { root: true })
        context.commit('updateInformationNature', response.data)
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la mise à jour de la nature (information) ${nature.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'nature/updateInformationNature', { root: true })
      })
  },
  deleteInformationNature (context, id) {
    return natureService.deleteInformationNature(id)
      .then(() => {
        context.dispatch('alert/success', 'Suppression réussie de la nature (information).', { root: true })
        context.commit('deleteInformationNature', id)
      })
  },
  createActionNature (context, nature) {
    context.dispatch('loader/startLoading', 'nature/createActionNature', { root: true })
    return natureService.createActionNature(nature)
      .then(response => {
        context.dispatch('alert/success', `Création réussie de la nature (action) ${response.data.label}.`, { root: true })
        context.commit('createActionNature', response.data)
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la création de la nature (action) ${nature.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'nature/createActionNature', { root: true })
      })
  },
  updateActionNature (context, { id, nature }) {
    context.dispatch('loader/startLoading', 'nature/updateActionNature', { root: true })
    return natureService.updateActionNature(id, nature)
      .then(response => {
        context.dispatch('alert/success', `Mise à jour réussie de la nature (action) ${response.data.label}.`, { root: true })
        context.commit('updateActionNature', response.data)
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la mise à jour de la nature (action) ${nature.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'nature/updateActionNature', { root: true })
      })
  },
  deleteActionNature (context, id) {
    return natureService.deleteActionNature(id)
      .then(() => {
        context.dispatch('alert/success', 'Suppression réussie de la nature (action).', { root: true })
        context.commit('deleteActionNature', id)
      })
  },
  createEventNature (context, nature) {
    context.dispatch('loader/startLoading', 'nature/createEventNature', { root: true })
    return natureService.createEventNature(nature)
      .then(response => {
        context.dispatch('alert/success', `Création réussie de la nature (événement) ${response.data.label}.`, { root: true })
        context.commit('createEventNature', response.data)
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la création de la nature (événement) ${nature.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'nature/createEventNature', { root: true })
      })
  },
  updateEventNature (context, { id, nature }) {
    context.dispatch('loader/startLoading', 'nature/updateEventNature', { root: true })
    return natureService.updateEventNature(id, nature)
      .then(response => {
        context.dispatch('alert/success', `Mise à jour réussie de la nature (événement) ${response.data.label}.`, { root: true })
        context.commit('updateEventNature', response.data)
        return response.data
      })
      .catch(() => {
        context.dispatch('alert/error', `Echec de la mise à jour de la nature (événement) ${nature.label}.`, { root: true })
      })
      .finally(() => {
        context.dispatch('loader/stopLoading', 'nature/updateEventNature', { root: true })
      })
  },
  deleteEventNature (context, id) {
    return natureService.deleteEventNature(id)
      .then(() => {
        context.dispatch('alert/success', 'Suppression réussie de la nature (événement).', { root: true })
        context.commit('deleteEventNature', id)
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
